import { compact, flow, map, prop, uniq } from 'lodash/fp'

import { PerformanceIndicator, PerformanceIndicatorType } from '../performanceIndicators/types'

export const isRangeType = (type: string | PerformanceIndicatorType) =>
  [PerformanceIndicatorType.linkedinRangeEmployees, PerformanceIndicatorType.crunchbaseRangeEmployees].includes(
    type as PerformanceIndicatorType
  )

export const isMonetaryType = (type: string | PerformanceIndicatorType) =>
  [PerformanceIndicatorType.monthlyRevenue, PerformanceIndicatorType.committedCapital].includes(
    type as PerformanceIndicatorType
  )

export const isRangePerformanceIndicator = ({ type }: Pick<PerformanceIndicator, 'type'>) => isRangeType(type)

export const isMonetaryPerformanceIndicator = ({ type }: Pick<PerformanceIndicator, 'type'>) => isMonetaryType(type)

export const getPerformanceIndicatorTypes = (): PerformanceIndicatorType[] => Object.values(PerformanceIndicatorType)

export const getPerformanceIndicatorLabel = (type: string | PerformanceIndicatorType) =>
  ({
    [PerformanceIndicatorType.linkedinEmployees]: 'HC Linkedin',
    [PerformanceIndicatorType.linkedinRangeEmployees]: 'Range Linkedin',
    [PerformanceIndicatorType.crunchbaseRangeEmployees]: 'Range CB',
    [PerformanceIndicatorType.monthlyRevenue]: 'Monthly revenue',
    [PerformanceIndicatorType.committedCapital]: 'Committed capital',
    [PerformanceIndicatorType.committedInvestors]: 'Committed investors',
    [PerformanceIndicatorType.otherTraction]: 'Other traction update',
  }[type] || 'Unknown type! :(')

export function getPerformanceIndicatorValue({ value }: Pick<PerformanceIndicator, 'value'>) {
  return value
}

export const getPerformanceIndicatorTextValue = flow(getPerformanceIndicatorValue, String)

export const isMonthlyRevenuePerformanceIndicator = ({ type }: Pick<PerformanceIndicator, 'type'>) =>
  type === PerformanceIndicatorType.monthlyRevenue

export const getUniqueTypes = (performanceIndicators: PerformanceIndicator[]): PerformanceIndicatorType[] =>
  flow(map(prop('type')), uniq, compact)(performanceIndicators)
